import React from 'react';

import cn from 'classnames';

import { IEmployee } from '@entities/employee/model/types';
import { AddEmployeeToTeam } from '@features';
import { UiButton } from '@shared/ui';
import { useAddEmployeeFromCompanyPage } from '@widgets/AddEmployeeFromCompanyPage/lib/hooks/useAddEmployeeFromCompanyPage';

import cls from './AddEmployeeFromCompanyPage.module.css';

interface AddEmployeeFromCompanyPageProps {
    classes?: string;
}

export const AddEmployeeFromCompanyPage = ({ classes }: AddEmployeeFromCompanyPageProps) => {
    const { onSuccessCb, onShowModal, isShow, onHideModal, t } = useAddEmployeeFromCompanyPage();

    return (
        <>
            {isShow && (
                <AddEmployeeToTeam<IEmployee> onCloseCb={onHideModal} onSuccessCb={onSuccessCb} />
            )}
            <div className={cn(cls.AddEmployerFromCompanyPage, [classes])}>
                <UiButton
                    onClick={onShowModal}
                    btnText={t('AddEmployeeFromCompanyPage.return.UiButton.btnText')}
                />
            </div>
        </>
    );
};
